import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
export class QDownloadRFC extends QRFC {
  constructor() {
    super();
    this.fFileName = null;
    this.fDirectory = null;
    //this.fMPTemplate = null;
    this.fLoadType = null;
    this.fLocked = null;
    this.fTopBoxID = null;
    this.fStartDiv = null;
    this.fSCID = null;
  }

  InitDownloadRFC(callbackObj, fileName, directory, loadType, isLocked, topBoxID, startDiv) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.fFileName = fileName;
    this.fDirectory = directory;
    this.fLoadType = loadType;
    //this.fMPTemplate = mpTemplate;
    this.fLocked = isLocked;
    this.fTopBoxID = topBoxID;
    this.fStartDiv = startDiv;
  }

  GetCallName() {
    return "qdownload";
  }

  SetParams(org, user, fileName, directory) {
    this.AddParameter("directory", directory);
    this.AddParameter("org", org);
    this.AddParameter("user", user);
    this.AddParameter("target", fileName);
    if (Globals._accountInfo.fReportToWebDriver) this.AddParameter("loadtype", -1);
    //TODO: In the future we can make this more sophisticated
    else this.AddParameter("loadtype", this.fLoadType);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    //callBackObj.DownloadResult(success, r, this.fFileName, this.fDirectory, this.fMPTemplate,this.fLocked, this.fTopBoxID, this.fStartDiv);
    callBackObj.DownloadResult(
      r,
      this.fFileName,
      this.fDirectory,
      this.fLoadType,
      this.fLocked,
      this.fTopBoxID,
      this.fStartDiv
    );
    if (this.fSCID != null) {
      var scm = Globals._wsMgr.GetSubChartMgr();
      scm.SetLoadedStatus(this.fSCID, true);
    }
  }
}
